import { Button, IconButton } from "@material-ui/core";
import React, { type ComponentProps, forwardRef, type ReactNode } from "react";

export type MenuButtonTriggerProps = {
  children?: ReactNode;
  isListOpen: boolean;
  listId: string;
} & Omit<
  ComponentProps<typeof Button>,
  "aria-haspopup" | "aria-owns" | "buttonRef"
>;

export const MenuButtonTrigger = forwardRef<
  HTMLButtonElement,
  MenuButtonTriggerProps
>(function MenuButtonTrigger({ children, isListOpen, listId, ...rest }, ref) {
  return (
    <Button
      aria-haspopup="true"
      aria-owns={isListOpen ? listId : undefined}
      buttonRef={ref}
      {...rest}
    >
      {children}
    </Button>
  );
});

export type MenuIconButtonTriggerProps = {
  children?: ReactNode;
  isListOpen: boolean;
  listId: string;
} & Omit<
  ComponentProps<typeof IconButton>,
  "aria-haspopup" | "aria-owns" | "buttonRef"
>;

export const MenuIconButtonTrigger = forwardRef<
  HTMLButtonElement,
  MenuIconButtonTriggerProps
>(function MenuIconButtonTrigger(
  { children, isListOpen, listId, ...rest },
  ref
) {
  return (
    <IconButton
      aria-haspopup="true"
      aria-owns={isListOpen ? listId : undefined}
      buttonRef={ref}
      {...rest}
    >
      {children}
    </IconButton>
  );
});
